import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import UploadLabsCsvFile from "./uploadLabCsvFile";
import CreateLabDetails from "./addLabDetails";
import LabCsvFormat from "./labCsvFormat";
import { toast } from "react-toastify";
import { Button, Modal, Pagination } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import "./hm-theme.css";

function RegulatedLabDetails() {
  const [labDetails, setLabDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCsvUplaodModalOpen, setIsCsvUplaodModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedLab, setSelectedLab] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);

  const regulated = true;
  const token = JSON.parse(localStorage.getItem("data")).token;
  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  const searchData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const searchUrl = `/api/labdetails/searchLabsByLabnameOrLabcode`;
      const response = await axios.post(searchUrl, { searchTerm }, {
        params: { page: pageNumber, regulated: true },
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabDetails(response.data.content || []);
      setCurrentPage(response.data.number || 0);
      setTotalPages(response.data.totalPages || 0);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const trans = await axios.get(`/api/labdetails/getAllRegulatedStatus/regulated=true`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setLabDetails(trans.data.content || []);
      setCurrentPage(trans.data.number || 0);
      setTotalPages(trans.data.totalPages || 0);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const handleDelete = (lab) => {
    setSelectedLab(lab);
    setShowConfirmationModal(true);
  };

  const handleDeleteConfirm = async () => {
    const options = { headers: { Authorization: `Bearer ${token}` } };
    try {
      setLoader(true);
      await axios.delete(`/api/labdetails`, { data: { id: selectedLab.id }, ...options });
      toast.success('Lab deleted successfully!');
      setShowConfirmationModal(false);
      setSelectedLab(null);
      getData(currentPage);
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  const handleViewLabDetails = (orgcode) => {
    navigate(`/users/lab-profile/${orgcode}`);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  return (
    <div>
      <Dashboard />
      {loader && <div className="loading"></div>}

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">biotech</i>
                Regulated Labs Directory
              </h2>
              <p className="hm-page-subtitle">Manage partner diagnostic labs and lab credentials</p>
            </div>
            <div className="d-flex align-items-center gap-2">
              <button className="btn btn-outline-primary rounded-pill px-3" onClick={() => setShowImageModal(true)}>
                Format Guide
              </button>
              <button className="btn btn-outline-secondary rounded-pill px-3" onClick={() => setIsCsvUplaodModalOpen(true)}>
                Upload CSV
              </button>
              <button className="btn-hm-primary" onClick={() => setIsModalOpen(true)}>
                <i className="material-icons" style={{ fontSize: "1rem" }}>add</i>
                Add Regulated Lab
              </button>
            </div>
          </div>

          {/* Search Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">search</i>
                Search Labs
              </h3>
            </div>
            <div className="hm-card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control ps-4"
                      placeholder="Search by lab name or code..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <i className="material-icons position-absolute text-muted" style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "1.1rem" }}>
                      search
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Table Card */}
          <div className="hm-card">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">science</i>
                Regulated Labs List
              </h3>
              <span className="hm-badge hm-badge-primary">{labDetails.length} labs</span>
            </div>
            <div className="hm-card-body p-0">
              <div style={{ overflowX: "auto" }}>
                <table className="hm-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Lab Name</th>
                      <th>Lab Code</th>
                      <th>Email / Username</th>
                      <th>Contact Number</th>
                      <th>Admin Link</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {labDetails.length === 0 ? (
                      <tr>
                        <td colSpan="7">
                          <div className="hm-empty-state">
                            <i className="material-icons">biotech</i>
                            <p>{loader ? "Loading labs..." : "No regulated labs found"}</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      labDetails.map((accd, index) => (
                        <tr key={accd.labcode}>
                          <td>{currentPage * 10 + index + 1}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-link p-0 fw-bold text-start text-decoration-none"
                              style={{ color: "#2f3a88" }}
                              onClick={() => handleViewLabDetails(accd.labcode)}
                            >
                              {accd.labname}
                            </button>
                          </td>
                          <td>
                            <span className="hm-badge hm-badge-primary">{accd.labcode}</span>
                          </td>
                          <td>{accd.username || "—"}</td>
                          <td>{accd.contact || "—"}</td>
                          <td>{accd.adminEmail || "—"}</td>
                          <td>
                            <button
                              className="btn btn-link text-danger p-0 border-0"
                              onClick={() => handleDelete(accd)}
                              title="Delete Lab"
                            >
                              <MdDeleteForever size={20} />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="d-flex justify-content-center py-3">
                  <Pagination className="hm-pagination">
                    <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                    {renderPageNumbers()}
                    <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages - 1} />
                    <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage >= totalPages - 1} />
                  </Pagination>
                </div>
              )}
            </div>
          </div>

        </div>
      </div>

      {isModalOpen && (
        <CreateLabDetails isOpen={isModalOpen} onRequestClose={() => { setIsModalOpen(false); getData(currentPage); }} regulated={regulated} />
      )}
      {isCsvUplaodModalOpen && (
        <UploadLabsCsvFile isOpen={isCsvUplaodModalOpen} onRequestClose={() => { setIsCsvUplaodModalOpen(false); getData(currentPage); }} regulated={regulated} />
      )}
      {showImageModal && (
        <LabCsvFormat isOpen={showImageModal} onRequestClose={() => setShowImageModal(false)} />
      )}

      <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Lab</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this lab?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="me-3" onClick={() => setShowConfirmationModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default RegulatedLabDetails;
